import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { AnimatePresence, motion } from "framer-motion";
import { cover, rem } from "polished";
import React from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { waitingOnMetaMaskAtom } from "../atoms";
import { useConnectorMeta } from "../modules/hooks";
import Notification from "./Notification";

const Whiteout = styled(motion.div)`
  ${cover()}
  position: fixed;
  z-index: 100;

  background: rgba(255, 255, 255, 0.7);
`;

const MetaMaskHUD = () => {
  const { t } = useTranslation();
  const waitingOnMetaMask = useRecoilValue(waitingOnMetaMaskAtom);
  const [walletName, walletLogo] = useConnectorMeta();

  return (
    <AnimatePresence>
      {waitingOnMetaMask ? (
        <>
          <Whiteout
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
          ></Whiteout>
          <motion.div
            animate={{
              opacity: 1,
              y: 42,
            }}
            css={css`
              position: fixed;
              z-index: 100;
              right: 0;
              left: 0;
              top: 0;
              margin: 0 auto;

              display: flex;
              justify-content: center;
            `}
            exit={{
              opacity: 0,
              y: 0,
            }}
            initial={{ opacity: 0 }}
          >
            <Notification
              css={css`
                border-radius: ${rem(84)};
                padding-left: ${rem(42)};
                padding-right: ${rem(42)};
              `}
              icon={walletLogo}
              subtitle={t("notifications.openWalletToContinue", { walletName })}
              title={t("notifications.waitingForApproval")}
            />
          </motion.div>
        </>
      ) : null}
    </AnimatePresence>
  );
};

export default MetaMaskHUD;
